<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <tilda_general_tab :location="location"></tilda_general_tab>
        </template>

        <template v-slot:location_categories="{ location, name }">
            <tilda_fields_tab :location="location" ></tilda_fields_tab>
        </template>

        <template v-slot:title_location_categories="{ location, name }">
            <div>Tilda Fields</div>
        </template>




    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import tilda_general_tab from "./tabs/tilda_general_tab";
import tilda_fields_tab from "./tabs/tilda_fields_tab";

export default {
    name: "tilda_location_modal",
    components : {
        tilda_general_tab,
        base_location_modal,
        tilda_fields_tab
    },
    data () {
        return {
            tabs_add : [

            ],

            tabs_remove:  [

                'location_logs',
                'location_products',

            ]
        }
    },
}
</script>

<style scoped>

</style>
